import { render, staticRenderFns } from "./DirectoryArchivedTableRow.vue?vue&type=template&id=db398574&scoped=true&"
import script from "./DirectoryArchivedTableRow.vue?vue&type=script&lang=js&"
export * from "./DirectoryArchivedTableRow.vue?vue&type=script&lang=js&"
import style0 from "./DirectoryArchivedTableRow.vue?vue&type=style&index=0&id=db398574&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db398574",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('db398574')) {
      api.createRecord('db398574', component.options)
    } else {
      api.reload('db398574', component.options)
    }
    module.hot.accept("./DirectoryArchivedTableRow.vue?vue&type=template&id=db398574&scoped=true&", function () {
      api.rerender('db398574', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/directories/DirectoryArchivedTableRow.vue"
export default component.exports